import { Modal } from "@general-backoffice/core";
import type { PaymentMethod } from "@investhinks/api-client";
import React from "react";
import { useTranslation } from "react-i18next";

interface RemovePaymentMethodModalProps {
  paymentMethod: PaymentMethod | null;
  close: () => void;
  remove: () => void | Promise<void>;
  isLoading?: boolean;
}

const RemovePaymentMethodModal: React.FC<RemovePaymentMethodModalProps> = ({
  paymentMethod,
  close,
  remove,
  isLoading,
}) => {
  const { t } = useTranslation("paymentMethods", { keyPrefix: "removePaymentMethodModal" });

  return (
    <Modal.DeleteConfirm
      isOpen={!!paymentMethod}
      isLoading={isLoading}
      toggleOpen={close}
      titleDelete={t("title")}
      descriptionDelete={t("text")}
      closeText={t("closeBtn")}
      buttonDelete={{ children: t("submitBtn"), onClick: remove }}
    />
  );
};

export default RemovePaymentMethodModal;
